import React from 'react';
import ArchitectureLayout from 'components/architecture/ArchitectureLayout';

/**
 * Architecture Components Page
 * Lists all architecture components with links to detailed pages
 */
const ArchitectureComponents = () => {
  const sections = [
    {
      id: 'overview',
      title: 'Architecture Components Overview',
      content: `Our platform is built on a comprehensive set of Azure services, each playing a critical role in delivering a scalable, secure, and reliable platform.

This page provides an overview of all major components. Click on any component to learn more about its architecture and implementation.`
    },
    {
      id: 'core-components',
      title: 'Core Components',
      content: `### Runtime
The execution enviroment that powers our serverless functions. Learn more about [Runtime](/architecture/runtime).

### Gateway
The API gateway that manages routing, authentication, and rate limiting. Learn more about [Gateway](/architecture/gateway).

### Compute
The serverless compute infrastructure that scales automatically. Learn more about [Compute](/architecture/compute).

### Database
The globally distributed database that ensures data consistency. Learn more about [Database](/architecture/database).`
    },
    {
      id: 'supporting-services',
      title: 'Supporting Services',
      content: `### Azure Key Vault
Secure storage and management of secrets, keys, and certificates. All sensitive configuration is stored in Key Vault and accessed at runtime.

### Azure Storage
Scalable cloud storage for files, blobs, queues, and tables. Used for:
- File uploads and downloads
- Queue-based messaging
- Static website hosting
- Backup storage

### Azure Application Insights
Comprehensive monitoring and analytics for:
- Application performance monitoring (APM)
- Error tracking and diagnostics
- Usage analytics
- Custom metrics and logging

### Azure SignalR Service
Real-time communication service for:
- Live progress updates
- Real-time notifications
- WebSocket connections
- Server-sent events (SSE)`
    },
    {
      id: 'architecture-diagram',
      title: 'Architecture Diagram',
      content: `\`\`\`mermaid
graph TB
    subgraph "Client Layer"
        A[Web Browser]
        B[Mobile App]
        C[API Clients]
    end
    
    subgraph "Gateway Layer"
        D[Azure API Management]
    end
    
    subgraph "Compute Layer"
        E[Azure Functions]
        F[Container Apps]
    end
    
    subgraph "Data Layer"
        G[MongoDB]
        H[Azure Storage]
        I[Key Vault]
    end
    
    subgraph "Services"
        J[Application Insights]
        K[SignalR Service]
    end
    
    A --> D
    B --> D
    C --> D
    D --> E
    D --> F
    E --> G
    E --> H
    E --> I
    F --> G
    F --> H
    E --> J
    E --> K
    F --> J
\`\`\``
    },
    {
      id: 'processes',
      title: 'API Processes',
      content: `Our platform exposes APIs through two main groups:

- **Customer Portal APIs**: Authenticated APIs for customer operations
- **Public APIs**: Public-facing APIs for integrations

Learn more about our [API Processes](/architecture/processes) and explore all available endpoints.`
    }
  ];

  return (
    <ArchitectureLayout
      title="Architecture Components"
      lastUpdated="2025-01-15"
      sections={sections}
    />
  );
};

export default ArchitectureComponents;

